// Union's own (design system artifact: components/Pennant). The pin flag: "this is yours /
// you are here" (your tee time, the current hole, the selected item). One per region; never a
// logo, bullet or decoration, never recoloured outside the primary.

import { cn } from "@union/ui/lib/utils";
import type * as React from "react";

const sizes = { default: "h-[18px] w-[14px]", lg: "h-[28px] w-[22px]" } as const;

function Pennant({
  size = "default",
  onPrimary = false,
  label,
  className,
  ...props
}: Omit<React.ComponentProps<"svg">, "children"> & {
  size?: keyof typeof sizes;
  /** On a primary fill (e.g. inside a primary button): pole and edge switch to primary-foreground. */
  onPrimary?: boolean;
  /** Read out by screen readers ("Your tee time"); omit when the text beside it says so. */
  label?: string;
}) {
  return (
    <svg
      data-slot="pennant"
      viewBox="0 0 14 18"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn("inline-block shrink-0 align-[-3px]", sizes[size], className)}
      {...props}
    >
      <rect
        x="0"
        y="0"
        width="2"
        height="18"
        rx="1"
        className={onPrimary ? "fill-primary-foreground" : "fill-foreground"}
      />
      <polygon
        points="2,0 14,5 2,10"
        className={onPrimary ? "fill-primary-foreground" : "fill-primary-text"}
      />
      <polygon points="2,2 10,5 2,8" className="fill-primary" />
    </svg>
  );
}

export { Pennant };
